__webpack_require__.p = "https://stg.static.uploader-widget.video.wds.io/";